<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg
      v-if="exceptionMsg"
      :msg="exceptionMsg"
      :image="exceptionImg"
    />

    <CityForm
      v-if="!isLoading && !isCatch"
      :cityData="cityData"
      :submitName="$t('edit')"
      v-on:addOrUpdateCity="updateCity"
    />
  </div>
</template>

<script>
import createToastMixin from "@/utils/create-toast-mixin";
import { STATUS } from "@/utils/constants";
import CityForm from "@/components/settings/settingsOther/cities/CityForm.vue";
import City from "@/models/settings/settingsOther/cities/City";

export default {
  name: "CityEdit",
  mixins: [createToastMixin],
  components: {
    CityForm,
  },
  data() {
    return {
      cityData: new City(),
      cityToken: this.$route.params.cityToken,
    };
  },
  methods: {
    async getCityDetails() {
      this.isLoading = true;
      this.cityData.cityToken = this.cityToken;
      try {
        let response = await this.cityData.getCityDetails(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.cityData.fillData(response.data.cityData);
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
          this.cityData = null;
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.cityData = null;
      }
      this.isLoading = false;
    },
    async updateCity() {
      this.isLoading = true;
      try {
        let response = await this.cityData.addOrUpdateCity(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$router.push({ name: "Cities" });
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.errorCatch();
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.getCityDetails();
  },
};
</script>

<style scoped lang="scss"></style>
